package com.example.socialmediaapp

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import com.example.socialmediaapp.navigation.AppNavigation
import com.example.socialmediaapp.ui.screens.SplashScreen
import com.example.socialmediaapp.ui.theme.AppDarkColorScheme

@Composable
fun App() {
    val tokenStorage = remember { TokenStorage() }
    var showSplash by remember { mutableStateOf(true) }

    MaterialTheme(colorScheme = AppDarkColorScheme) {
        if (showSplash) {
            SplashScreen(onSplashComplete = { showSplash = false })
        } else {
            AppNavigation(tokenStorage = tokenStorage)
        }
    }
}
